/* eslint-disable no-mixed-operators */
import CardTemplate from "../../Genericos/CardTemplate/CardTemplate";
import TurnoPresencialIcon from "../../../assets/images/generico/TurnoPresencialIcon";
import TurnoVideoConsultaIcon from "../../../assets/images/generico/TurnoVideoConsultaIcon";
import "./CardTurno.css";
import CardTurnoAlerts from "./CardTurnoAlerts";
import CardTurnoFooter from "./CardTurnoFooter";
import CardTurnoBody from "./CardTurnoBody";
import CardTurnoAgreement from "./CardTurnoAgreement";

const CardTurno = ({ idPacienteFamiliar, recargoTurnos, turno }) => {
  return (
    <div className="ptur-cardTurno">
      <CardTemplate
        classTemplateBox={`ptur-card-template-box`}
        classTittleBox="ptur-card-turno-titleBox"
        tituloCard={`${turno.especialidad}`}
        iconTituloCard={true}
        imgTittle={
          turno.videoConsulta === true ? (
            <TurnoVideoConsultaIcon />
          ) : (
            <TurnoPresencialIcon />
          )
        }
        bodyCard={
          <div className="ptur-card-cardTurno-content">
            <CardTurnoAlerts turno={turno} />
            <CardTurnoBody turno={turno} />
            <CardTurnoAgreement />
            <CardTurnoFooter turno={turno} idPacienteFamiliar={idPacienteFamiliar} recargoTurnos={recargoTurnos} />
          </div>
        }
      />
    </div>
  );
};

export default CardTurno;
